/**
 * Terms of Use 页 —— 直接渲染 src/content/terms.html
 */
import termsHtml from '@/content/terms.html?raw';

export default function Page() {
  return (
    <div className="container" style={{ padding: '64px 24px', maxWidth: 800 }}>
      <h1 style={{ fontSize: 36, fontWeight: 700, marginBottom: 32 }}>Terms of Use</h1>
      <div dangerouslySetInnerHTML={{ __html: termsHtml }} />
    </div>
  );
}
